export default __webpack_public_path__ + "static/media/welcome_bg.ee3e0705.png";